import axios from 'axios'
import {i18n} from '@/plugins/vue-i18n/vue-i18n.js'
import {onBeforePageUnload} from '@/helpers'

let handlers = Symbol('handlers')

function makeObservable(target) {
  target[handlers] = []
  target.observe = function(handler) {
    this[handlers].push(handler)
  }
  return new Proxy(target, {
    set(target, property, value, receiver) {
      let success = Reflect.set(...arguments)
      if (success) {
        target[handlers].forEach(handler => handler(value))
      }
      return success
    }
  })
}

let refreshing = {
  status: false
}

refreshing = makeObservable(refreshing)

function appendSlash(request) {
  if (!request.url.endsWith('/')) {
    request.url += '/'
  }
}


const apiAuthRoot = axios.create({
  baseURL: process.env.VUE_APP_AUTH_API_ROOT,
  withCredentials: true,
  transformRequest: [function (data, headers) {


    return data
  }, ...axios.defaults.transformRequest]
})


apiAuthRoot.interceptors.request.use(request => {
  appendSlash(request)

  return request
}, null)


const apiV2AuthRoot = axios.create({
  baseURL: process.env.VUE_APP_API_ROOT,
  withCredentials: true
})

apiV2AuthRoot.interceptors.request.use(request => {
  appendSlash(request)
  // request.params = {...request.params, t: Date.now() }
  return request
}, null)

apiV2AuthRoot.interceptors.request.use(
  async (config) => {
    const scope = localStorage.getItem('scope')
    if(!refreshing.status) {
      let accessToken = localStorage.getItem('access_token')
      const accessTTL = Number(localStorage.getItem('access_ttl'))

      if (accessToken) {
        if (accessTTL <= Date.now()) {
          accessToken = await refreshAccessToken()
        }
        config.headers['Authorization'] = `Bearer ${accessToken}`

        config.headers['Src-App'] = scope
      }
    } else {
      await refreshingObserve()
      let accessToken = localStorage.getItem('access_token')
      config.headers['Authorization'] = `Bearer ${accessToken}`
      config.headers['Src-App'] = scope
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

function refreshingObserve() {
  return new Promise((resolve, reject) => {
    refreshing.observe((status) => {
      if(!status) {
        resolve(true)
      }
    })
  })
}



apiV2AuthRoot.interceptors.response.use(null, async (error) => {
  if (error.response?.status === 503 && window.location.pathname !== `/${i18n.locale}/server_is_not_available`) {
    window.location = `/${i18n.locale}/server_is_not_available`
  }
  if (error.response?.status === 401
    && window.location.pathname !== `/${i18n.locale}/login`
    && window.location.pathname !== `/${i18n.locale}/register`
    && window.location.pathname !== `/${i18n.locale}/register/`
    && window.location.pathname !== `/${i18n.locale}/register/final`
    && window.location.pathname !== `/${i18n.locale}/register/sharing`
    && window.location.pathname !== `/${i18n.locale}/register/sharing/success`
    && window.location.pathname !== `/${i18n.locale}/document-sign/sharing/success`) {
     logout()

  }
  return Promise.reject(error)
})

async function refreshAccessToken() {
  refreshing.status = true
  const refresh = localStorage.getItem('refresh_token')
  const refreshTTL = localStorage.getItem('refresh_ttl')
  if(refreshTTL > Date.now()) {
    try {
      const accessTTL = Number(localStorage.getItem('access_ttl_limit'))
      const refreshTTL = Number(localStorage.getItem('refresh_ttl_limit'))
      const requestTime = Date.now()
      const {data} = await apiAuthRoot.post('auth/token/refresh', {refresh})
      refreshing.status = false

      localStorage.setItem('access_token', data.access)
      localStorage.setItem('refresh_token', data.refresh)
      localStorage.setItem('access_ttl', requestTime + accessTTL)
      localStorage.setItem('refresh_ttl', requestTime + refreshTTL)
      return data.access
    } catch (err) {
      console.log(err)
      return false

    }
  } else {
    logout()
  }
}


function logout() {
  localStorage.removeItem('access_token')
  localStorage.removeItem('refresh_token')
  const locale = ['en', 'uk'].includes(i18n.locale) ? i18n.locale : 'uk'
  window.removeEventListener('beforeunload', onBeforePageUnload)
  window.location = `/${locale}/login`
}

export {
  apiAuthRoot,
  apiV2AuthRoot
}


